<template>
  <div class="app-media-object">
    <div class="media">
      <div class="app-media-object__icon">
        <slot name="icon" />
      </div>
      <div class="media-body">
        <div class="app-media-object__info card-subtitle">
          <slot name="info" />
        </div>
        <h5 class="app-media-object__content">
          <slot />
        </h5>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppMediaObject'
};
</script>

<style lang="scss">
.app-media-object {
  display: flex;
  flex-direction: column;
  background-color: $--color-white;
  border-radius: $--spacing-2;

  &__icon {
    color: $--color-red;
    align-self: center;
    margin-right: $--spacing-6;
  }

  &__content {
    color: $--color-red;
    margin-bottom: 0;
  }

  &__info {
    color: $--color-gray;
  }
}
</style>
